{
	"errorCloseProject": "Close Project",
	"multiWindowWarningMessage": "Opening the same project in multiple browser windows can cause undefined behaviors. Are you sure you want to open this project?",
	"openAnyway": "Open Anyway",
	"projectAlreadyActiveMessage": "This project is already active in another browser window or tab. To open it in this window, please ensure it is closed elsewhere and try again.",
	"projectAlreadyActiveTitle": "Project already active",
	"projectDuplicateAccessMessage": "This project is opened in another browser window or tab. Do you want to close it in this window or stay in the project?",
	"stayInProject": "Stay in Project",
	"stayInProjectWarningMessage": "Opening the same project in multiple browser windows can cause undefined behaviors. Are you sure you want to stay in this project?"
}
